import BasicText from "@/components/BasicText";
import Subtitle from "@/components/Subtitle";
import Title from "@/components/Title";

const Ecosystem: React.FC = () => {
  const rows = [
    {
      title: "Ecosystem Fund",
      percent: 25,
      description:
        "The Ecosystem Fund is a proactive program meant to stimulate development in the Collective ecosystem by providing funding to projects and communities.",
    },
    {
      title: "Retroactive Public Good Funding (RetroPGF)",
      percent: 20,
      description:
        "RetroPGF is the Optimism Collective’s primary mechanism to adequately and reliably reward public goods for the impact they provide.",
    },
    {
      title: "User airdrops",
      percent: 19,
      description:
        "A series of airdrops to reward users for specific helpful behaviors, beginning with Airdrop #1.",
    },
    {
      title: "Core Contributors",
      percent: 19,
      description:
        "The people who’ve been working tirelessly to bring the Optimism Collective into existence.",
    },
    {
      title: "Sugar xaddies",
      percent: 17,
      description: "Investors",
    },
  ];
  return (
    <div className="flex flex-col items-center justify-center px-8 py-20 md:p-20 shadow-inner-glow">
      <div className="flex flex-col gap-10 md:gap-0 md:flex-row w-full justify-between items-center">
        <div>
          <Subtitle>// ALLOCATION</Subtitle>
          <Title>Ecosystem Allocation</Title>
        </div>

        <BasicText className="max-w-[310px]" size="14px" color="faded">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Soluta sed
          voluptatum, deserunt magni natus incidunt! Iusto perferendis quod
          ratione sint.
        </BasicText>
      </div>

      <div className="flex flex-col mt-10 w-full min-h-[80vh]">
        {rows.map((component) => {
          return (
            <div
              className="w-full px-4 font-geist-mono font-[500] flex-1
                border-[1px] border-[#22222f] odd:bg-[#22222f26] odd:backdrop-blur-sm odd:shadow-inner-glow"
              style={{
                mask: "polygon(20% 0%, 100% 0%, 100% 100%, 0% 100%, 0% 40%);",
              }}
            >
              <BasicText className="items-center">
                <div className="flex-col md:flex-row flex text-[18px] items-start md:items-center justify-stretch gap-4 p-5">
                  <div className="flex-[2] height-[93px] flex gap-5">
                    <span className="font-bold text-luminode-blue"> + </span>
                    <BasicText color="white" size="18px">{component.title}</BasicText>
                  </div>
                  <div className="flex-1 height-[93px]">
                    <BasicText color="white" size="18px">{component.percent}%</BasicText>
                  </div>
                  <div className="flex-[3] text-[14px]">
                    <BasicText color="faded" size="14px">{component.description}</BasicText>
                  </div>
                </div>
              </BasicText>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Ecosystem;
